export var schemaPriceRange = function (priceRange) {
    if (!priceRange) {
        return "";
    }
    var definitions = {
        budget: "$",
        "mid-range": "$$",
        "top-end": "$$$",
    };
    return definitions[priceRange] || "";
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/utils/schema/schemaPriceRange.ts
// module id = gO5h
// module chunks = 2